<template>

  <splitpanes class="default-theme" horizontal>
    <!-- 工作流可视化 -->
    <pane min-size="33" size="33">
      <div :id="containerId" ref="graph_container" class="graph_container"></div>
    </pane>

    <pane min-size="30">
          <el-scrollbar>
            <div class="form_box">
              <div v-for="(queryData,index) in currentNodeQueryDataList" :key="index">
                <div class="form_title">
                  <div style="margin-right: 40px">{{ queryData.node_name }}</div>
                </div>
                <div v-if="queryData.query_id !='0'">
                  <frame-query v-if="queryData.query_id =='chance_details'"
                               @click="searchByScene()"
                               ref="frameQuery"
                               componentParam="chance_details"
                               :parent-data="{sales_user_id:this.user_id, scene_id:this.scene_id}">
                  </frame-query>
                  <FrameQuery v-if="queryData.query_id !='chance_details'"
                              ref="frameQuery"
                              :component-param="queryData.query_id"
                              :key="queryData.query_id"
                              :init-data="queryData"
                              @click="searchByScene"
                  ></FrameQuery>
                </div>
                <FrameForm v-if="queryData.form_id !='0'"
                           :component-param="queryData.form_id"
                           :key="queryData.form_id"
                           :init-data="queryData">
                </FrameForm>
                <div v-if="queryData.item_id !='0'">
                  <PayReceiveBoard v-if="queryData.item_id =='PayReceive/PayReceiveBoard'"></PayReceiveBoard>
                  <ChanceBoard v-if="queryData.item_id =='crm/ChanceBoard'"></ChanceBoard>
                </div>
              </div>
            </div>
          </el-scrollbar>
    </pane>

  </splitpanes>
</template>

<script>

const messages = {
  zhCn: {
    label1: '工作流类型:',
    label2: '工作流编号:',
    label3: '创建用户:',
    label4: '创建时间:',
    label5: '期望完成时间:',
    label6: '流程超时:',
    label7: '流程图',
    label8: '流程日志',
    label9: '时间',
    label10: '执行用户',
    label11: '流程节点',
    label12: '操作类型',
    check_page2: '该任务已提交过！',
    check_page1: '参数工作流任务ID为空！',
    error1: '获取表单定义信息失败，',
  },
  en: {
    label1: 'Workflow type:',
    label2: 'Workflow number:',
    label3: 'Create user:',
    label4: 'Creation time:',
    label5: 'Expected completion time:',
    label6: 'Process timed out:',
    label7: 'Flow Chart',
    label8: 'Process Logs',
    label9: 'Time',
    label10: 'Executing user',
    label11: 'Process node',
    label12: 'Type of operation',
    check_page2: 'The task has been submitted！',
    check_page1: 'The parameter Workflow task ID is empty',
    error1: 'Failed to get form definition information，',
  }
}

import {mxConstants, mxEdgeStyle, mxEvent, mxGraph} from 'mxgraph-js'
import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import ChanceBoard from "@/views/applications/crm/ChanceBoard.vue";
import PayReceiveBoard from "@/views/applications/payReceive/PayReceiveBoard.vue";

export default {
  name: "FrameBusPrc",
  i18n: {messages},
  components: {PayReceiveBoard, ChanceBoard, Splitpanes, Pane},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    // parentData: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // },
  },
  data() {
    return {
      processData: {},
      queryDataList: [],
      currentNodeQueryDataList: [],
      currentNodeId: '',
      currentQueryIdx: 0,
      nodes: [],
      routes: [],
      graph: {},
      containerId: new Date().getTime(),
      user_id: '',
      scene_id: '',
      sceneChance: [],
      cntList: [],
    }
  },
  provide() {
    return {
      $fn: {
        reload: () => {
          this.afterBtnClick();
        }
      }
    }
  },
  methods: {
    searchByScene() {
      this.currentNodeQueryDataList.forEach((queryData, index) => {
        this.$nextTick(() => {
          this.$refs.frameQuery[index].search();
        })
      })
    },

    afterBtnClick() {
      this.clearImage();
      this.loadPrcTaskInfo();
    },

    //根据流程模板id获取业务流数据
    async loadPrcTaskInfo() {
      console.log("componentParam-=" + this.componentParam);
      if (!this.componentParam) {
        return this.$message.error(this.$t('check_page1'));
      }

      let params = {id: this.componentParam}
      this.processData = await this.$http('busPrcService.getBusPrcTaskInfo', params)

      this.drawProcess(this.processData);
    },

    // getButtonClass(index) {
    //   console.log("3112121-=" ,index)
    //   if (this.currentQueryIdx === index) {
    //     return "query_switch_button_active";
    //   }
    //   return "query_switch_button";
    // },

    //处理业务流数据
    drawProcess(processData) {
      console.log("drawProcess start...")
      if (!processData) {
        return this.$message.error(`工作流数据为空！`);
      }

      this.processData = processData;
      let templateObj = processData.template;
      this.nodes = templateObj?.nodes || [];
      this.queryDataList = processData.query_data_list;

      this.getNodeBadgeCnt(this.queryDataList);

      if (this.nodes.length == 0) {
        return;
      }
      this.drawImage();

      //默认显示第一个节点的表单内容
      if (this.queryDataList.length > 0) {
        var queryData = this.queryDataList[0];
        this.currentNodeId = queryData.node_id;
        this.setCurrentForms();
        this.destroy();
      }
    },

    //为表单准备数据
    setCurrentForms() {
      var cleared = false;
      if (!this.currentNodeId || this.currentNodeId.length == 0) {
        return;
      }

      for (var i = 0; i < this.queryDataList.length; i++) {
        var queryData = this.queryDataList[i];
        if (queryData.node_id && this.currentNodeId == queryData.node_id) {
          if (!cleared) {
            this.currentNodeQueryDataList.lenth = 0;
            this.currentNodeQueryDataList = [];
          }

          cleared = true;
          this.currentNodeQueryDataList.push(queryData);
          this.scene_id = queryData.scene_id;
        }
      }
      this.currentQueryIdx = this.currentNodeQueryDataList.length - 1;

      this.searchByScene();

      //强制更新视图
      this.$forceUpdate();
    },
    //获取默认销售
    async getSalesUser() {
      this.user_id = this.$store.state.core.currentUser.id
    },

    destroy(){
      this.graph.destroy();
      this.drawImage();
    },

    //绘制流程图
    drawImage() {
      console.log("drawImage start");
      // 创建画布
      var graph = new mxGraph(this.$refs.graph_container);
      this.graph = graph;
      graph.setEnabled(false); //设置启用,就是允不允许你改变CELL的形状内容。
      graph.setVertexLabelsMovable(false);

      var style = graph.getStylesheet().getDefaultEdgeStyle();
      style[mxConstants.STYLE_EDGE] = mxEdgeStyle.ElbowConnector; //自己拐弯的连线
      style[mxConstants.STYLE_FONTSIZE] = 16; //文字大小
      style[mxConstants.STYLE_FONTCOLOR] = "ff00ff";
      graph.getView().updateStyle = true; // 动态改变样式

      var parent = graph.getDefaultParent();
      //开始更新画布
      graph.getModel().beginUpdate();


      var that = this;
      //添加点击事件
      graph.addListener(mxEvent.CLICK, function (sender, evt) {
        //console.log('click in ...');
        var e = evt.getProperty('event'); // mouse event
        var cell = evt.getProperty('cell'); // cell may be null
        if (cell != null) {
          var id = cell.id;
          that.currentNodeId = cell.id
          console.log('that.currentNodeId=' + that.currentNodeId);
          that.destroy();
          that.setCurrentForms();

          evt.consume();
        }
      });

      try {
        //空白矩形
        // if (this.componentParam === 'business_prc'){
        //   var whiteStyle = this.getWhiteNodeStyle();
        //   var busName = "业务流程";
        //   graph.insertVertex(null, null, busName, 2, 0, 1450, 280, whiteStyle);
        //   var name = "场景数据";
        //   graph.insertVertex(null, null, name, 1470, 0, 475, 280, whiteStyle);
        // }

        // 插入节点
        var nodeObjects = {}
        for (var i = 0; i < this.nodes.length; i++) {
          var nodeData = this.nodes[i];
          var id = nodeData.id;
          var style = this.getNodeStyle(nodeData);
          var cell = graph.insertVertex(parent, null, nodeData.name, nodeData.x, nodeData.y, 110, 60, style);
          cell.id = id
          cell.name = nodeData.name;
          nodeObjects[id] = cell;
        }

        //插入左上数据条数
        for (var i = 0; i < this.nodes.length; i++) {
          var nodeData = this.nodes[i];
          //节点上显示数据条数
          var edgesStyle = this.getEdgesNodeStyle();
          var nodeDataX = nodeData.x - 10;
          var nodeDataY = nodeData.y - 7;
          if (this.cntList[i]?.node_id == nodeData.id && this.cntList[i]?.query_id != '0') {
            var cnt = this.cntList[i]?.cnt;
            graph.insertVertex(null, null, cnt, nodeDataX, nodeDataY, 45, 25, edgesStyle);
          }
        }

        //插入线条
        for (var i = 0; i < this.nodes.length; i++) {
          var nodeData = this.nodes[i];
          var routes = nodeData.routes || [];
          for (var j = 0; j < routes.length; j++) {
            var routeData = routes[j];
            //出发节点id
            var fromId = routeData.source_node;
            //到达的节点id
            var toId = routeData.target_node;

            if (nodeObjects[fromId] && nodeObjects[toId]) {
              var lineStyle = this.getRouteStyle(routeData);
              var hasBreakPoints = routeData.break_points && routeData.break_points.length > 0;
              var label = routeData.label || '';
              var edge = graph.insertEdge(parent, null, label, nodeObjects[fromId], nodeObjects[toId], lineStyle);
              //设置折线点
              if (hasBreakPoints) {
                edge.geometry.points = routeData.break_points
              }
            }
          }
        }
      } finally {
        // 画布更新结束
        graph.getModel().endUpdate();
      }
    },
    clearImage() {
      //var graph = this.graph;
      //开始更新画布
      //graph.getModel().beginUpdate();
      //graph.removeCells(graph.getChildVertices(graph.getDefaultParent())); //清空画布
      //graph.getModel().endUpdate();

      document.getElementById(this.containerId).innerHTML = "";
    },

    //节点上显示数据条数
    getNodeBadgeCnt(queryDataList) {
      this.queryDataList = queryDataList;
      if (!queryDataList) {
        return this.$message.error(`未找到节点数据！`);
      }
      for (var i = 0; i < this.queryDataList.length; i++) {
        var queryData = this.queryDataList[i];
        this.cntList.push(queryData);
      }
    },

    //节点上显示数据条数样式
    getEdgesNodeStyle() {
      var edgesStyle = 'fontSize=13;fontColor=white;rounded=1;perimeter=ellipsePerimeter;arcSize=50;fillColor=red ';
      return edgesStyle;
    },
    //空白框
    getWhiteNodeStyle() {
      var whiteStyle = 'fontSize=30;fontColor=black;align=lift;verticalAlign=top;fillColor=white;strokeColor=black';
      return whiteStyle;
    },

    //节点样式
    getNodeStyle(nodeData) {
      var style = 'fontSize=14;whiteSpace=pre-wrap';

      if (this.currentNodeId == nodeData.id){
        console.log("2121221212122-=",nodeData.id)
        style = style + ';strokeColor=orange;strokeWidth=3';
      }
      if (nodeData.current) {
        style = style + ';strokeColor=orange;strokeWidth=3';
      } else if (nodeData.finish) {
        style = style + ';strokeColor=#33cc66;strokeWidth=3';
      }

      if (nodeData.disabled) {
        style = style + ';fillColor=#aaa;strokeWidth=1';
      } else if (nodeData.fill_color) {
        style = style + ';strokeWidth=1;fillColor=' + nodeData.fill_color;
      }

      if (nodeData.start || nodeData.end) {
        style = style + ';rounded=1;perimeter=ellipsePerimeter;arcSize=30';
      }

      if (nodeData.font_color) {
        style = style + ';fontColor=' + nodeData.font_color;
      }
      return style;
    },
    getRouteStyle(routeData) {
      var normalStyle = 'edgeStyle=elbowEdgeStyle;';
      var activeStyle = 'edgeStyle=elbowEdgeStyle;strokeWidth=3;strokeColor=#33cc66';
      var lineStyle = normalStyle;
      if (routeData.finish) {
        lineStyle = activeStyle;
      } else if (routeData.color) {
        lineStyle = normalStyle + "strokeColor=" + routeData.color;
      }
      return lineStyle;
    }

  },
  mounted() {
    this.loadPrcTaskInfo();
  },
  created() {
    this.getSalesUser();
    // var qqq = this.getNodeBadgeCnt();
    // console.log("1111-=" ,qqq)

  },
}
</script>


<style lang="less" scoped>

.splitpanes__pane {
  background-color: white !important;
}

.splitpanes__splitter {
  background-color: whitesmoke !important;
}

.graph_container {
  background-color: white;
}

.form_switch_toolbar {
  display: inline-flex;
  padding: 5px;
}

.form_switch_button {
  display: inline-block;
  margin-right: -2px;
}

.form_switch_button_active {
  display: inline-block;
  margin-right: -2px;
  border-color: #0a84ff;
}

.form_title {
  background-color: whitesmoke;
  border: 1px solid #e5e5e5;
  height: 45px;
  line-height: 45px;
  font-size: 30px;
  padding-left: 80px;
  margin-top: -1px;
  width: 100%;
  display: inline-flex;

}

</style>
